module.exports = __webpack_public_path__ + "img/alarm-status.f43de1bd.svg";